/* Spiral Seven — flash sale countdown bar.

   Display only. The prices themselves are genuinely changed for the window by
   ~/.spiralseven/flash-sale/bin/flash_sale.py (every sale item floored at half
   its compare-at price), so this file must NOT touch prices — the theme already
   renders the real ones.

   Three phases, from window.SS7_FLASH:
     before teaser     hidden
     teaser -> start   "HALF PRICE SALE STARTS IN ..."   counting to 7:30pm
     start  -> end     "HALF PRICE SALE ENDS IN ..."     counting to 9pm
     after end         hidden

   It also refreshes the page ONCE as it crosses each boundary, so someone
   parked on the site watches the prices drop at 7:30 without touching anything,
   and stops being shown half prices at 9:00 after they have been put back.
   Server-rendered prices are baked into the HTML at load, so without this a
   parked page keeps showing whatever it was serving when it loaded.

   The clock is judged on the CLIENT clock, not in Liquid: Shopify's CDN caches
   storefront HTML, so a Liquid time check can be served stale at either edge.

   Keep the dates in step with snippets/ss7-flash-sale.liquid. */
(function () {
  var CFG = window.SS7_FLASH;
  if (!CFG || !CFG.start || !CFG.end) return;

  var teaserMs = (CFG.teaser || CFG.start) * 1000;
  var startMs = CFG.start * 1000;
  var endMs = CFG.end * 1000;

  /* When THIS page was rendered. Everything about the refresh hangs off it. */
  var loadedAt = Date.now();
  var refreshed = {};

  function unit(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 'S');
  }

  /* "11 HOURS 24 MINS 09 SECS", dropping the hours segment once it is zero so
     the last hour reads "45 MINS 09 SECS" rather than "0 HOURS 45 MINS". */
  function clock(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(t / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    var out = [];
    if (h > 0) out.push(unit(h, 'HOUR'));
    out.push(unit(m, 'MIN'));
    out.push(unit(s, 'SEC'));
    return out.join(' ');
  }

  /* Refresh at most once per boundary.

     The loop guard that actually matters is `loadedAt < boundary`: a page can
     only refresh for a boundary it was open BEFORE. After the reload the new
     page's loadedAt is past that boundary, so it cannot fire again — even if
     storage is unavailable or the clock jumps. sessionStorage is a second belt,
     and is wrapped because Safari private mode throws on access. */
  function shouldRefresh(name, boundary, now) {
    if (loadedAt >= boundary) return false;
    if (now < boundary) return false;
    if (refreshed[name]) return false;
    try {
      if (sessionStorage.getItem('ss7_flash_refreshed_' + name)) return false;
    } catch (e) { /* storage blocked — the loadedAt guard still holds */ }
    return true;
  }

  function markRefreshed(name) {
    refreshed[name] = true;
    try {
      sessionStorage.setItem('ss7_flash_refreshed_' + name, '1');
    } catch (e) { /* no-op */ }
  }

  /* The theme pins a toolbar along the bottom on mobile (.t4s-toolbar). Sit
     above it rather than over it, or the bar buries the site's bottom nav on
     the viewport most of the traffic uses. Measured, not hard-coded. */
  function positionBar(el) {
    var lift = 0;
    var others = document.querySelectorAll('.t4s-toolbar, [class*="toolbar"]');
    for (var i = 0; i < others.length; i++) {
      var o = others[i];
      if (o === el || el.contains(o)) continue;
      var cs = getComputedStyle(o);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var b = o.getBoundingClientRect();
      if (b.height < 10 || b.width < 50) continue;
      if (Math.abs(b.bottom - window.innerHeight) > 4) continue;
      if (b.height > lift) lift = b.height;
    }
    el.style.bottom = Math.round(lift) + 'px';
  }

  function tick() {
    var now = Date.now();

    /* Prices flipped under this page — re-render it from the server. */
    if (shouldRefresh('start', startMs, now)) {
      markRefreshed('start');
      window.location.reload();
      return;
    }
    if (shouldRefresh('end', endMs, now)) {
      markRefreshed('end');
      window.location.reload();
      return;
    }

    var el = document.getElementById('ss7-flash-bar');
    if (!el) return;

    if (now < teaserMs || now >= endMs) {
      el.hidden = true;
      document.body.classList.remove('ss7-flash-on');
      return;
    }

    var live = now >= startMs;
    el.hidden = false;
    document.body.classList.toggle('ss7-flash-on', live);
    positionBar(el);

    var label = el.querySelector('[data-ss7-flash-label]');
    var time = el.querySelector('[data-ss7-flash-clock]');
    if (label) {
      label.textContent = live
        ? 'HALF PRICE SALE ENDS IN'
        : 'HALF PRICE SALE STARTS IN';
    }
    if (time) time.textContent = clock((live ? endMs : startMs) - now);
  }

  function init() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
